import { AxiosError, AxiosResponse } from 'axios';

export const errorInterceptor = (error: AxiosError): AxiosResponse => {
  return processAxiosError(error);
};

export const processAxiosError = (error: AxiosError) => {
  return {
    ...error.response,
    data: mapErrorToErrorResponse(error),
  } as AxiosResponse<ApiResponse>;
};

export const mapErrorToErrorResponse = (e: unknown): ErrorResponse => {
  const error = e as AxiosError;
  // typescriptはコンパイル時での確認ですが、実行時の確認が必要
  if (error.response && error.response.data.result) {
    return error.response.data as ErrorResponse;
  } else {
    return { result: generateDefaultErrorResult() };
  }
};

export const generateDefaultErrorResult = (): Result => {
  return {
    jobDateTime: generateJobDateTime(),
    resultCd: '500',
    resultMessageDtoList: [
      {
        resultMessageCd: 'E_002',
        resultMessage: 'システムエラーが発生しました。',
      },
    ],
  };
};

export const generateJobDateTime = () => {
  return new Date()
    .toISOString()
    .replace(/[^0-9]/g, '')
    .slice(0, 14);
};
